const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 126 \\u2013 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 189",
    d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10z",
    style: {
      fill: "none",
      stroke: "#0052cc",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    transform: "translate(-1 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 190",
    d: "m15 9-6 6",
    style: {
      fill: "none",
      stroke: "#0052cc",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    transform: "translate(-1 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 191",
    d: "m9 9 6 6",
    style: {
      fill: "none",
      stroke: "#0052cc",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    transform: "translate(-1 -1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.a045f878608114953a62a23ff4b803cc.svg";
export { ForwardRef as ReactComponent };